type DiaTalkLogoProps = {
  className?: string;
} & React.SVGProps<SVGSVGElement>;

export const DiaTalkLogo = ({ className, ...props }: DiaTalkLogoProps) => {
  return (
    <svg
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      width={500}
      height={181.6}
      viewBox="0 0 500 181.6"
      // @ts-expect-error - style is not typed
      style={{ enableBackground: 'new 0 0 500 181.6' }}
      xmlSpace="preserve"
      className={className}
      {...props}
    >
      <defs>
        <style>{`.st0{fill:#575771;}`}</style>
      </defs>
      <path
        className="st0"
        d="M0,180.1V0h33.1c12,0,20.7,2.6,26,7.9c5.3,5.3,8.1,14,8.3,26.1c0.2,13.4,0.4,26,0.5,38c0.1,12,0.1,24,0,36
	c-0.1,12-0.2,24.6-0.5,38c-0.2,12.2-3,20.9-8.4,26.2c-5.4,5.3-14.1,7.9-26.2,7.9H0z M19.7,162.5h13.2c9.7,0,14.6-4.8,14.9-14.5
	c0.7-38.7,0.7-77.4,0-116.2c-0.2-9.5-5.1-14.3-14.6-14.3H19.7V162.5z M97,180.1V45h19.7v135.1H97z M168.7,181.6
	c-8,0-13.9-2.2-17.7-6.6c-3.8-4.4-6-11.2-6.8-20.5c-0.1-1.8-0.2-3.7-0.2-5.6c-0.1-2,0-3.8,0.1-5.5c0.5-8.2,2.6-15.1,6.2-20.7
	c3.6-5.6,10.1-10.7,19.5-15.4c6.7-3.5,13.7-6.6,21.2-9.3V72c0-4.7-0.9-8.1-2.7-10.2c-1.8-2.2-5.1-3.3-9.8-3.3
	c-4.1,0-7.1,0.9-9.1,2.8c-1.9,1.8-3,5.2-3.2,10.2c-0.2,2.3-0.2,5.7-0.2,10.1c0,4.4,0.1,8,0.2,11h-19.1c-0.2-2.4-0.3-5.5-0.3-9.2
	c-0.1-3.7,0-7,0.1-10c0.4-10.6,3-18.2,7.8-23c4.8-4.7,13-7.1,24.4-7.1c11.9,0,20.1,2.6,24.7,7.7c4.5,5.1,6.8,13.5,6.8,25.2
	l-0.1,103.9h-19.6v-12.7H188c-1.9,4.7-4.3,8.2-7.1,10.6C177.9,180.4,173.9,181.6,168.7,181.6z M175.9,166.9c7.1,0,12.1-4,15.1-12
	v-42.3c-2.6,0.9-5.3,2-7.9,3.3c-2.7,1.3-5.5,3-8.6,5.2c-4.2,2.8-7,6-8.4,9.7c-1.4,3.7-2.3,7.9-2.5,12.6c0,1.4,0,3,0,4.7
	c0,1.7,0,3.4,0.1,5C164.4,162.3,168.5,166.9,175.9,166.9z M240.4,180.1V17.6H216V0h68.4v17.6H260v162.5H240.4z M311.6,181.6
	c-8,0-13.9-2.2-17.7-6.6c-3.8-4.4-6-11.2-6.8-20.5c-0.1-1.8-0.2-3.7-0.2-5.6c-0.1-2,0-3.8,0.1-5.5c0.5-8.2,2.6-15.1,6.2-20.7
	c3.6-5.6,10.1-10.7,19.5-15.4c6.7-3.5,13.7-6.6,21.2-9.3V72c0-4.7-0.9-8.1-2.7-10.2c-1.8-2.2-5.1-3.3-9.8-3.3
	c-4.1,0-7.1,0.9-9.1,2.8c-1.9,1.8-3,5.2-3.2,10.2c-0.2,2.3-0.2,5.7-0.2,10.1c0,4.4,0.1,8,0.2,11h-19.1c-0.2-2.4-0.3-5.5-0.3-9.2
	c-0.1-3.7,0-7,0.1-10c0.4-10.6,3-18.2,7.8-23s13-7.1,24.4-7.1c11.9,0,20.1,2.6,24.7,7.7c4.5,5.1,6.8,13.5,6.8,25.2l-0.1,103.9h-19.6
	v-12.7h-2.9c-1.9,4.7-4.3,8.2-7.1,10.6C320.8,180.4,316.7,181.6,311.6,181.6z M318.8,166.9c7.1,0,12.1-4,15.1-12v-42.3
	c-2.6,0.9-5.3,2-7.9,3.3c-2.7,1.3-5.5,3-8.6,5.2c-4.2,2.8-7,6-8.4,9.7c-1.4,3.7-2.3,7.9-2.5,12.6c0,1.4,0,3,0,4.7c0,1.7,0,3.4,0.1,5
	C307.3,162.3,311.3,166.9,318.8,166.9z M382.7,180.1V0h19.6v180.1H382.7z M432.2,180.1V0h18.5v44.9l-2.1,58.6h3.8l9.2-26.1L474.4,45
	h20.5l-24.2,54.6l29.3,80.5h-20.4l-21-59.9l-7.5,15v44.9H432.2z M475.2,0v13.5c4.8,1.3,8.5,3.3,11.1,6.1c2.3,2.4,4.1,5.6,5.4,9.5
	c0.2,0.5,0.6,0.8,1,0.8h2.2V0H475.2z M97.1,0v29.9h2.2c0.5,0,0.9-0.3,1-0.8c1.3-3.9,3.1-7.1,5.4-9.5c2.6-2.8,6.3-4.8,11.1-6.1V0
	L97.1,0z"
      />
    </svg>
  );
};
